<template>
  <input
    type="text"
    class="afizo"
    :value="value"
		@focus="$emit('focus')"
		@blur="$emit('blur')"
    @input="$emit('input', $event.target.value)" />
</template>

<script>
export default {
	name: "j-base-input-text",

	props: {
		value: {
			required: true,
			default: null,
			validator(val) {
				return val === null || typeof val === "string"
			},
		},
	},
}
</script>

<style scoped>
@import "../../assets/css/tokens.css";
@import "../../assets/css/mixins.css";

.afizo {
	display: block;
	width: 100%;
	padding: var(--spacing2);
	background-color: var(--color5);
	border: 1px solid var(--color7);
	border-radius: var(--borderRadius1);
	font-family: var(--fontFamily1);
	font-weight: var(--fontWeight400);
	line-height: var(--lineHeight100);
	color: var(--color1);
	outline: 0;
	height: var(--inputsHeightNormal);
	font-size: var(--inputsFontSizeNormal);
	-webkit-appearance: none;
	-moz-appearance: none;
}

.afizo::placeholder {
	color: var(--color7);
	font-size: inherit;
}

/* Sizes */
.afizo.xsmall {
	height: var(--inputsHeightXsmall);
	font-size: var(--inputsFontSizeXsmall);
}
.afizo.small {
	height: var(--inputsHeightSmall);
	font-size: var(--inputsFontSizeSmall);
}
.afizo.large {
	height: var(--inputsHeightLarge);
	font-size: var(--inputsFontSizeLarge);
}
.afizo.xlarge {
	height: var(--inputsHeightXlarge);
	font-size: var(--inputsFontSizeXlarge);
}

/* States */
.afizo:focus {
	border-color: var(--color6);
}

.afizo.success {
	border-color: var(--colorSuccess);
}

.afizo.error {
	outline: 2px solid var(--colorError);
	outline-offset: -1px;
	animation: shake 900ms ease-out both;
}

.afizo.warning {
	border-color: var(--colorWarning);
}

/* Desktops */
@media (--md) {
	.afizo {
		transition: all 80ms ease-out;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/JBaseInputText/index.vue